import './base-theme'
import { styled } from '@mui/material'

export default styled
